import ajax from '@/utils/request'

// 列表
export const logList = data => ajax('/api/log/get/list/', data, 'POST')
// 详情
export const logDetail = data => ajax('/api/log/get/', data, 'GET')
